import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { selectBonusOffers } from '../selectors';
import { triggerBonusOffers300x250IsViewed } from '../actions';

export const useTriggerBonusOffers300x250GAEvents = (shouldTriggerViewGAEvent) => {
  const bonusOffers = useSelector(selectBonusOffers);
  const dispatch = useDispatch();

  const triggerViewEvent = () => {
    bonusOffers.forEach((offer) => {
      dispatch(triggerBonusOffers300x250IsViewed(offer));
    });
  };

  useEffect(() => {
    if (!isEmpty(bonusOffers)) {
      shouldTriggerViewGAEvent && triggerViewEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bonusOffers]);
};
